export function deleteJwtCookie() {
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

    document.cookie = `__ac=; Domain=.ict.uniba.it; Path=/; expires=${expires};`;
    document.cookie = `__ac=; Domain=.ict.uniba.it; Path=/; Secure; expires=${expires};`;
    document.cookie = `__ac=; Domain=.ict.uniba.it; Path=/; SameSite=Lax; expires=${expires};`;
    document.cookie = `__ac=; Domain=.ict.uniba.it; Path=/; SameSite=None; Secure; expires=${expires};`;
}